module.exports = __webpack_public_path__ + "img/p1-info.39687f1c.jpg";